import { render, staticRenderFns } from "./tx-sub-classifier-prefs.vue?vue&type=template&id=0797672e&scoped=true&"
import script from "./tx-sub-classifier-prefs.ts?vue&type=script&lang=ts&"
export * from "./tx-sub-classifier-prefs.ts?vue&type=script&lang=ts&"
import style0 from "./tx-sub-classifier-prefs.scss?vue&type=style&index=0&id=0797672e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0797672e",
  null
  
)

export default component.exports